function n(t) {
  return t == null || Array.isArray(t) && t?.length < 1 || typeof t == "object" && Object.keys(t)?.length < 1 || t === "";
}
export {
  n as default
};
